import { createTheme } from '@mui/material/styles';

// CC_TEMA_ESTUDIO_NOITE (2026-09-28, pedido do usuario): "deixa so um tema dark, mas que seja bem visual
// a tela de conversas". Antes eram duas camadas brigando -- este arquivo em azul-marinho (#08101e, azul
// #1e88e5) e, por cima, a personalizacao salva no banco em roxo (#8A7DCC) com fundos azul-arroxeados --
// pouco contraste e cara de tema "misturado". Agora: grafite neutro levemente quente (sem azul), UMA cor
// de destaque (ambar "NO AR", usado com parcimonia: aba ativa, botao principal, nao lidas) e o verde fica
// so onde ja e WhatsApp (balao enviado, icones). As cores personalizadas do banco sao IGNORADAS aqui de
// proposito (so o logo continua vindo de la), pra nao voltar a misturar.
export const T = {
    bg:         '#101113', // fundo do app
    surface:    '#16181B', // listas, paineis, cards
    surface2:   '#1D2024', // hover, inputs, elevados
    surface3:   '#25292E', // selecionado
    border:     '#262A2F',
    borderSoft: 'rgba(255,255,255,0.06)',
    text:       '#ECEDEF',
    text2:      '#A7ADB5',
    text3:      '#767C85',
    accent:     '#F2A93B', // ambar "NO AR"
    accentHi:   '#F7BD62',
    accentInk:  '#1B1206', // texto sobre o ambar
    green:      '#25D366',
    chatBg:     '#0C0D0F',
    bubbleIn:   '#1F2226',
    bubbleOut:  '#005C4B',
    bubbleInk:  '#E9EDEF',
    danger:     '#F26D6D',
    info:       '#7CC4FF',
};
const a = (hex, o) => {
    const h = hex.replace('#', '');
    return `rgba(${parseInt(h.slice(0, 2), 16)},${parseInt(h.slice(2, 4), 16)},${parseInt(h.slice(4, 6), 16)},${o})`;
};
const R = 10;
const FONT = '"Onest", "Segoe UI", system-ui, sans-serif';
export const MONO = '"IBM Plex Mono", ui-monospace, "SFMono-Regular", monospace';

const getDarkTheme = (config, locale) =>
    createTheme(
        {
            shape: { borderRadius: R },
            typography: {
                fontFamily: FONT,
                fontSize: 13,
                fontWeightLight: 300,
                fontWeightRegular: 400,
                fontWeightMedium: 500,
                fontWeightBold: 700,
                h1: { fontSize: '2rem',    fontWeight: 700, letterSpacing: '-0.02em' },
                h2: { fontSize: '1.75rem', fontWeight: 700, letterSpacing: '-0.02em' },
                h3: { fontSize: '1.5rem',  fontWeight: 600, letterSpacing: '-0.01em' },
                h4: { fontSize: '1.25rem', fontWeight: 600 },
                h5: { fontSize: '1.1rem',  fontWeight: 600 },
                h6: { fontSize: '1rem',    fontWeight: 600 },
                body1: { fontSize: '0.875rem', fontWeight: 400, lineHeight: 1.6 },
                body2: { fontSize: '0.82rem',  fontWeight: 400, lineHeight: 1.5 },
                button: { fontSize: '0.82rem', fontWeight: 600, textTransform: 'none' },
                caption: { fontSize: '0.75rem', fontWeight: 400 },
            },
            components: {
                MuiCssBaseline: {
                    styleOverrides: `
                        @import url('https://fonts.googleapis.com/css2?family=Onest:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap');
                        * { box-sizing: border-box; }
                        body { background-color: ${T.bg}; color: ${T.text}; -webkit-font-smoothing: antialiased; }
                        ::selection { background: ${a(T.accent, 0.35)}; color: ${T.text}; }
                        ::-webkit-scrollbar { width: 6px; height: 6px; }
                        ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 4px; }
                        ::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.22); }
                        ::-webkit-scrollbar-track { background: transparent; }
                        :focus-visible { outline: 2px solid ${a(T.accent, 0.7)}; outline-offset: 2px; }
                        input:-webkit-autofill,
                        input:-webkit-autofill:hover,
                        input:-webkit-autofill:focus {
                            -webkit-box-shadow: 0 0 0 100px ${T.surface2} inset !important;
                            -webkit-text-fill-color: ${T.text} !important;
                        }
                    `,
                },
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundImage: 'none',
                            backgroundColor: T.surface,
                            border: `1px solid ${T.border}`,
                            borderRadius: R,
                        },
                    },
                },
                MuiCard: {
                    styleOverrides: {
                        root: {
                            backgroundImage: 'none',
                            backgroundColor: T.surface2,
                            border: `1px solid ${T.border}`,
                            borderRadius: R,
                        },
                    },
                },
                MuiButton: {
                    styleOverrides: {
                        root: { borderRadius: 8 },
                        containedPrimary: {
                            background: T.accent,
                            color: T.accentInk,
                            fontWeight: 700,
                            borderRadius: 8,
                            boxShadow: 'none',
                            '&:hover': { background: T.accentHi, boxShadow: `0 4px 14px ${a(T.accent, 0.25)}` },
                        },
                        outlined: {
                            borderRadius: 8,
                            borderColor: T.border,
                            color: T.text,
                            '&:hover': { borderColor: T.text3, backgroundColor: 'rgba(255,255,255,0.04)' },
                        },
                        text: { color: T.text2, '&:hover': { color: T.text, backgroundColor: 'rgba(255,255,255,0.05)' } },
                    },
                },
                MuiIconButton: {
                    styleOverrides: {
                        root: { borderRadius: 8, color: T.text2, '&:hover': { color: T.text, backgroundColor: 'rgba(255,255,255,0.06)' } },
                    },
                },
                MuiListItem: {
                    styleOverrides: { root: { backgroundColor: 'transparent' } },
                },
                MuiListItemButton: {
                    styleOverrides: {
                        root: {
                            borderRadius: 8,
                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.04)' },
                            '&.Mui-selected': {
                                backgroundColor: T.surface3,
                                '&:hover': { backgroundColor: T.surface3 },
                            },
                        },
                    },
                },
                MuiMenuItem: {
                    styleOverrides: {
                        root: {
                            borderRadius: 6,
                            backgroundColor: 'transparent',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' },
                            '&.Mui-selected': { backgroundColor: T.surface3 },
                        },
                    },
                },
                MuiInputBase: {
                    styleOverrides: {
                        root: { color: T.text, borderRadius: 8 },
                        input: { '&::placeholder': { color: T.text3, opacity: 1 } },
                    },
                },
                MuiOutlinedInput: {
                    styleOverrides: {
                        root: {
                            borderRadius: 8,
                            backgroundColor: T.surface2,
                            '& fieldset': { borderColor: T.border, borderRadius: 8 },
                            '&:hover fieldset': { borderColor: '#3A4047' },
                            '&.Mui-focused fieldset': { borderColor: a(T.accent, 0.8) },
                        },
                        input: { color: T.text },
                    },
                },
                MuiFilledInput: {
                    styleOverrides: {
                        root: {
                            borderRadius: 8,
                            backgroundColor: T.surface2,
                            '&:hover': { backgroundColor: T.surface2 },
                            '&.Mui-focused': { backgroundColor: T.surface2 },
                        },
                    },
                },
                MuiSelect: {
                    styleOverrides: {
                        select: { borderRadius: 8, backgroundColor: T.surface2, color: T.text },
                    },
                },
                MuiTableContainer: {
                    styleOverrides: { root: { backgroundColor: T.surface, borderRadius: R } },
                },
                MuiTableCell: {
                    styleOverrides: {
                        root: { borderBottom: `1px solid ${T.border}`, color: T.text, backgroundColor: 'transparent' },
                        head: {
                            backgroundColor: T.surface2,
                            color: T.text2,
                            fontWeight: 600,
                            fontSize: '0.72rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.06em',
                        },
                    },
                },
                MuiTableRow: {
                    styleOverrides: { root: { '&:hover td': { backgroundColor: 'rgba(255,255,255,0.03)' } } },
                },
                MuiChip: {
                    styleOverrides: {
                        root: {
                            borderRadius: 6,
                            backgroundColor: T.surface3,
                            color: T.text2,
                            border: `1px solid ${T.border}`,
                        },
                        colorPrimary: { backgroundColor: a(T.accent, 0.16), color: T.accentHi, borderColor: a(T.accent, 0.3) },
                    },
                },
                MuiTooltip: {
                    styleOverrides: {
                        tooltip: {
                            borderRadius: 6,
                            backgroundColor: '#2B2F35',
                            color: T.text,
                            border: `1px solid ${T.border}`,
                            fontSize: '0.75rem',
                        },
                    },
                },
                MuiDivider: {
                    styleOverrides: { root: { borderColor: T.border } },
                },
                MuiDrawer: {
                    styleOverrides: {
                        paper: {
                            borderRadius: 0,
                            backgroundColor: '#0D0E10',
                            backgroundImage: 'none',
                            borderRight: `1px solid ${T.border}`,
                        },
                    },
                },
                MuiAppBar: {
                    styleOverrides: {
                        root: { backgroundImage: 'none', backgroundColor: '#0D0E10', borderBottom: `1px solid ${T.border}`, boxShadow: 'none' },
                    },
                },
                MuiDialog: {
                    styleOverrides: {
                        paper: { borderRadius: 14, backgroundColor: T.surface, backgroundImage: 'none', border: `1px solid ${T.border}` },
                    },
                },
                MuiPopover: {
                    styleOverrides: {
                        paper: {
                            borderRadius: R,
                            backgroundColor: T.surface2,
                            backgroundImage: 'none',
                            border: `1px solid ${T.border}`,
                            boxShadow: '0 12px 32px rgba(0,0,0,0.55)',
                        },
                    },
                },
                MuiMenu: {
                    styleOverrides: {
                        paper: { borderRadius: R, backgroundColor: T.surface2, backgroundImage: 'none', border: `1px solid ${T.border}` },
                        list: { padding: '4px' },
                    },
                },
                MuiTab: {
                    styleOverrides: {
                        root: {
                            borderRadius: 6,
                            color: T.text3,
                            fontWeight: 500,
                            '&:hover': { color: T.text2 },
                            '&.Mui-selected': { color: T.text, fontWeight: 600 },
                        },
                    },
                },
                MuiTabs: {
                    styleOverrides: {
                        indicator: { background: T.accent, height: 2, borderRadius: '2px 2px 0 0' },
                    },
                },
                MuiAccordion: {
                    styleOverrides: {
                        root: {
                            borderRadius: `${R}px !important`,
                            backgroundColor: T.surface2,
                            backgroundImage: 'none',
                            '&:before': { display: 'none' },
                        },
                    },
                },
                MuiAccordionSummary: {
                    styleOverrides: { root: { borderRadius: R, backgroundColor: T.surface2 } },
                },
                MuiSwitch: {
                    styleOverrides: {
                        track: { backgroundColor: 'rgba(255,255,255,0.18)' },
                        switchBase: { '&.Mui-checked + .MuiSwitch-track': { backgroundColor: T.accent, opacity: 0.55 } },
                    },
                },
                MuiLinearProgress: {
                    styleOverrides: { root: { borderRadius: 4, backgroundColor: a(T.accent, 0.15) } },
                },
                MuiBadge: {
                    styleOverrides: {
                        badge: { fontFamily: MONO, fontWeight: 500 },
                        colorSecondary: { backgroundColor: T.accent, color: T.accentInk },
                        colorPrimary: { backgroundColor: T.accent, color: T.accentInk },
                    },
                },
                MuiAvatar: {
                    styleOverrides: { root: { borderRadius: 10 } },
                },
            },
            scrollbarStyles: {
                '&::-webkit-scrollbar': { width: '6px', height: '6px' },
                '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(255,255,255,0.12)', borderRadius: '4px' },
            },
            palette: {
                mode: 'dark',
                primary:     { main: T.accent, light: T.accentHi, dark: '#C9862A', contrastText: T.accentInk },
                secondary:   { main: T.text2 },
                toolbar:     { main: '#0D0E10' },
                menuItens:   { main: '#0D0E10' },
                sub:         { main: T.surface },
                toolbarIcon: { main: T.text },
                divide:      { main: T.border },
                background: { default: T.bg, paper: T.surface },
                text: { primary: T.text, secondary: T.text2, disabled: T.text3 },
                divider: T.border,
                action: {
                    hover:    'rgba(255,255,255,0.05)',
                    selected: T.surface3,
                    disabled: 'rgba(255,255,255,0.3)',
                },
                success: { main: T.green },
                warning: { main: T.accent },
                error:   { main: T.danger },
                info:    { main: T.info },
            },
            chat: T,
            backgroundImage: 'none',
        },
        locale
    );

export default getDarkTheme;
